export default __webpack_public_path__ + "static/media/remove.fafaf8e6.svg";